import {ReactNode} from 'react';
import {Navigate} from 'react-router';
import {useParams} from 'react-router-dom';
import {ROUTE_PATHS} from '@di-shared/routes';

export interface ExchangeHistoryIdGuardProps {
  vin: string;
  children(vin: string, historyId: string): ReactNode;
}

function HistoryIdGuard({vin, children}: ExchangeHistoryIdGuardProps): JSX.Element {
  const params = useParams<{historyId: string}>();

  if (!params.historyId) {
    return (
      <Navigate
        to={ROUTE_PATHS.ERROR.getFullPath()}
        replace
      />
    );
  }

  return <>{children(vin, params.historyId)}</>;
}

export default HistoryIdGuard;
